import { Injectable } from '@angular/core';

import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import {  FormGroup } from '@angular/forms';
import * as firebase from 'firebase/app';

// rxjs
import { Subscription, pipe, of  } from 'rxjs';


import { AuthService } from '../core/auth.service';
import { Observable } from 'rxjs/Rx';

import { AuditRecord } from './auditRecordModel'
import { User } from 'shared-stuff'
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, filter, tap } from 'rxjs/operators';
import { P } from '@angular/core/src/render3';
import { UserModule } from 'app/views/user/user.module';

@Injectable()
export class auditLogService {
  
  public subs:Subscription[]

  currentUID: string // pulled out of the URL
  currentUserRef: AngularFirestoreDocument<User>
  user: Observable<User>;
  userAuditLogExists: boolean = false;
  auditRecord: AuditRecord;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private db: AngularFirestore
     ) {  
      //  this.subs = new Array<Subscription>();
      //  this.subs.push( this.auth.uidBS.subscribe(value => {
      //    this.currentUID = value;     
      //  }))
      }

     ngOnIt(formInp: FormGroup){ 
     }     

     setUserDoc(): boolean{
     this.currentUID = this.auth.uid;
      
       try{
        if(this.currentUID){
          //this.db.doc<User>(`users/${this.currentUID}`).set(new this.user, { merge: true })
          this.currentUserRef = this.db.doc(`users/${this.currentUID}`)
          return true;
        } else {
          return false;
        }
      } catch (ex) {
        console.log("unable to set user doc in auditLog")
        console.log("unable to set user doc in auditLog")
        return false;
      }
    }   

     addRecord()
     addRecord(changeLocation: string, actionTaken:string)
     addRecord(changeLocation: string, actionTaken:string, uploadId:string)
     addRecord(changeLocation: string, actionTaken:string, form: FormGroup)
     addRecord(changeLocation?: string, actionTaken?:string, uploadIdOrForm?: string | FormGroup){             
        
      var promise = new Promise((resolve, reject) => {
        if(!this.setUserDoc()) { return; };
        this.auditRecord = new AuditRecord();        

        if(changeLocation) this.auditRecord.changeLocation = changeLocation;
        if(actionTaken) this.auditRecord.actionTaken = actionTaken;
        if(uploadIdOrForm && typeof uploadIdOrForm === 'string') this.auditRecord.uploadId = uploadIdOrForm;
        else if(uploadIdOrForm){          
          this.auditRecord.formChanges = this.getFormChanges(uploadIdOrForm as FormGroup);
          //If form has no changes, do not add record. Case when Save and continue is clicked with no changes
          if(Object.keys(this.auditRecord.formChanges).length == 0) {
            resolve();
            return promise;
          }
        }
          
        this.currentUserRef.update({
            auditLog: firebase.firestore.FieldValue.arrayUnion(
                this.auditRecord.package()                    
            )
        }).then(
          success => {resolve()},
          failure => {  reject(failure)}
        )
      });
      return promise;
     }

     getFormChanges(formInp: FormGroup){  
        let retVal = {};    
        Object.keys(formInp.controls).forEach(key => {
          let currentControl = formInp.controls[key];          
          if(currentControl.dirty){
            retVal[key] = currentControl.value;
          }
        })    
        return retVal;      
      }

     
    ngOnDestroy() {
        // destroy all the subscriptions at once
        this.subs.forEach(
          val => val.unsubscribe()
        );
    }

}


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/services/auditLog.service.ts